import React from "react"
import { FaCode, FaDraftingCompass, FaAndroid } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title1: "web development",
    text1: "I enjoy seeing what I code comes to life in the browser, even if it takes some of my time debugging. ",
    title2: "Languages I code:",
    text2: "jamstack",
    title3: "Dev. Tools",
    text3: "VScode, Github, Gatsbyjs",
  },
  {
    id: 2,
    icon: <FaDraftingCompass className="service-icon" />,
    title1: "web and mobile app design",
    text1: "I help top organizations and celebrities turn their idea into design, and also come up with an amazing design even with little brief. ",
    title2: "Things I enjoy designing:",
    text2: "UI, Web, Mobile, Apps, Logos",
    title3: "Design Tools",
    text3: "Pen & paper, Figma, Sketch, Canvas",
  },
  {
    id: 3,
    icon: <FaAndroid className="service-icon" />,
    title1: "app development",
    text1: "creating apps gave me joy and seeing it add value to people inspired me to build more",
    title2: "what i built:",
    text2: "Android apps with kotlin",
    title3: "Dev. Tools",
    text3: "Android Sutdio ",
  },
]
